import { Grid } from "@mui/material";

const Contact = () => {
  return (
    <>
      <div className="contact-container">
        <div className="address">
          <h1>Let's get in touch</h1>

          <h4>We're open for any suggestion or just to have a chat</h4>
          <div>
            <i class="fa-solid fa-location-dot"></i>
            <p>Super Market Depalpur (Okara)</p>
          </div>
          <div>
            <i class="fa-solid fa-phone"></i>
            <p>Phone: +92 312 6156636</p>
          </div>
          <div>
            <i class="fa-sharp fa-solid fa-envelope"></i>
            <p>Email: kaleemullah987@gmail.com</p>
          </div>
          <div>
            <i class="fa-brands fa-internet-explorer"></i>
            <p>Website: www.websole.com</p>
          </div>
        </div>
        <form action="" className="form">
          <h1 className="form-h1">Get in touch with us</h1>
          <p className="form-p1">We will be happy to answer your question</p>
          <input type="text" name="" id="" placeholder="Name" />
          <input type="email" name="" id="" placeholder="Email" />
          <input type="number" name="" id="" placeholder="Contact" />
          <input type="text" name="" id="" placeholder="Message" />
          <button className="form-btn">Send</button>
        </form>
      </div>
    </>
  );
};

export default Contact;
